import { createSelector } from 'reselect'

const getExtraData = state => state.user.extra
const defaultTooltips = {}

const tooltipsSelector = createSelector(
	[getExtraData],
	extra => ({
		tooltips: extra ? extra.tooltips : defaultTooltips,
	})
)

export default tooltipsSelector
